export class ClassSubjectReq {
    classId: number;
    subject: number;
    constructor(classId: number, subject: number) {
        this.classId = classId;
        this.subject = subject;
    }
}